<template>
  <div class="post" 
    v-bind:class="[ {
      circle_border : entry.circle_id !== null && entry.official_circle != false,
      'private-circle' : entry.circle_id !== null && entry.official_circle == false,
      'myspace-only' : entry.entry_division_id === 4 && entry.official_range === 4
    } ]">
    <!-- 枠、左上三角 -->
    <div v-if="(entry.circle_id != null && entry.official_circle==false) || (entry.entry_division_id === 4 && entry.official_range === 4)"
      v-bind:class="[{
        'Item-Content-Flg2': entry.circle_id != null && entry.official_circle==false,
        'Item-Content-Flg3': entry.entry_division_id === 4 && entry.official_range === 4,
      }]"></div>
    <font-awesome-icon 
      icon="ellipsis-v" 
      class="other-action">
    </font-awesome-icon>
    <!-- ランチャーメニュー -->
    <LauncherMenu 
      v-if="isEditable() && !isDetailMode()" 
      :entry="entry">
    </LauncherMenu>
    <div class="user">
      <AccountAnchorImage 
        v-if = "entry && entry.account_id != null && !entry.entry_as_circle" 
        :has-img = "entry.has_img" 
        :account-id = "entry.account_id" 
        :account-name = "entry.account_name" />
      <CircleAnchorImage 
        v-else-if = "entry && entry.circle_id != null && entry.entry_as_circle " 
        :has-img = "entry.has_circle_img" 
        :circle-id = "entry.circle_id" 
        :circle-name = "entry.circle_name"></CircleAnchorImage>
      <div class="data">
        <div class="user-name" v-show="entry.account_name != null ">
          <router-link v-show="!entry.entry_as_circle" :to = "{ name:'MyspaceTimeLine', params:{ accountId: entry.account_id} }" style="text-decoration: none">{{entry.account_name}}</router-link>
          <!-- フォローコンポーネント -->
          <LabelAccountFollow 
            :follow-account-id="entry.account_id" 
            v-if="loginFlg && account && (entry.account_id != account.id) && !entry.entry_as_circle"></LabelAccountFollow>
          <div class="tag owner">
            <span class="name" v-if="entry.entry_division_id == 2 && entry.entry_as_circle">サークルとして投稿</span>
            <span class="new_name" v-if="account != null && (entry.already_read_flg === false || (entry.unread_marks != null && entry.unread_marks.length > 0))">新着</span>
          </div>
          <span 
            v-if="account != null && data.unreadDisplay"  
            v-observe-visibility="{ callback: onVisibilityNew, throttle: 0, intersection: { threshold: 0}}">ああ
          </span>
        </div>
        <div class="posted-date">
          <router-link :to = "{ name:'EntryDetail', params:{ entryId: entry.id} }" style="text-decoration: none">{{updated_at}}に投稿</router-link>

          <div class="friend-only" v-if="entry.entry_division_id == 4">
            <svg version="1.1" id="friend-only" class="day-before" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
              <g>
                <path class="friend-only" d="M36.2,52.2C36.2,52.2,36.1,52.2,36.2,52.2c-0.1,0-0.1,0-0.2,0c-14.5,0-26.3,6.5-26.3,14.4v14.8h21.8h9.2h21.8V66.6
                  C62.5,58.7,50.7,52.2,36.2,52.2z"/>
                  <path class="friend-only" d="M36.2,52.2C36.2,52.2,36.1,52.2,36.2,52.2c-0.1,0-0.1,0-0.2,0c-14.5,0-26.3,6.5-26.3,14.4v14.8h21.8h9.2h21.8V66.6
                  C62.5,58.7,50.7,52.2,36.2,52.2z"/>
                <path class="friend-only" d="M68.2,57c-1.2,0-2.5,0.1-3.6,0.2c4,2.5,6.5,5.8,6.5,9.5v14.8h19.2V69C90.2,62.4,80.4,57,68.2,57z"/>
                <circle class="friend-only" cx="36.2" cy="31.1" r="12.5"/>
                <circle class="friend-only" cx="68.2" cy="39.3" r="10.5"/>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- 通常投稿 -->
    <div :class="entry.text.length > 100 ? 'post-more': 'post'" v-if="!Boolean(entry.is_rss)">
      <input v-if="entry.text.length > 100" class="more" type="checkbox" :id="'trigger-post-more-' + entry.id" />
      <label v-if="entry.text.length > 100" class="more-btn" :for="'trigger-post-more-' + entry.id"></label>
      <p v-html="entryText"></p>
      <p v-if="Boolean(entry.has_thumbnail)">
        <ThumbnailImage :entry-id="entry.id" />
      </p>
    </div>
    <!-- rss投稿 -->
    <div class="post-more-rss" v-else>
      <p class="rss">
        <span v-html="entry.text" ></span><br />
      </p>
      <p v-if="Boolean(entry.has_thumbnail)">
        <ThumbnailImage :entry-id="entry.id" />
      </p>
    </div>
    <div class="tag circle">
      <span class="name" v-show=" entry.circle_name != null ">
        <router-link 
          :to = "{ name:'circle/time-line', params:{ circleMode: 1, circleId: entry.circle_id} }" 
          style="text-decoration: none">{{entry.circle_name}}</router-link>
      </span>
    </div>
    <div class="feedback">
      <!-- しるしをしたユーザリンク -->
      <MarksLink :mark-count="data.markCount" :entry-id="entry.id" :refresh-flg="data.marksLinkReload" @on-reloaded="toggleMarksLinkReload" />
      <!-- 詳細画面で表示 -->
      <CommentCountAnchor 
        v-show="!isDetailMode()" 
        :entry-id="entry.id" 
        :count="data.commentCount" ></CommentCountAnchor>
    </div>
    <div class="action">
      <MarkDialog :entry-id="entry.id" @on-marked="toggleMarksLinkReload"></MarkDialog>
      <div class="action-comment">
          <div class="action" @click="changeCommentDisplay()">
          <svg version="1.1" id="icon-comment" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.9 23.6" style="enable-background:new 0 0 27.9 23.6;" xml:space="preserve">
            <path class="icon-comment" d="M19.3,1c-0.1,0-0.2,0-0.3,0c-1.5,0-3.1,0-4.6,0c-0.4,0-2.5,0-5,0C8.7,1,8.3,1.1,8.1,1.1C3.4,2,0.3,6.7,1.2,11.4                        c0.8,4.1,4.4,7.1,8.6,7.1c1.2,0,2.4,0,3.6,0c0.3,0,0.6,0.1,0.8,0.3c1.2,1,2.4,2,3.7,2.9c0.4,0.3,0.9,0.6,1.4,0.8                        c0.7,0.3,1.6,0,1.9-0.7c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.2-0.7,0.2-1.1c0-0.7,0-1.4,0-2.1c0-0.3,0.1-0.6,0.4-0.8                        c3.3-1.6,5.3-5.1,4.9-8.8C26.5,4.8,23.3,1.5,19.3,1L19.3,1z"></path>
          </svg>
          <span>コメント</span>
        </div>
      </div>
    </div>
    <!-- <div class="comment" v-observe-visibility="{ callback: onVisibilityComment, throttle: 0, intersection: { threshold: 0}}"> -->
    <div class="comment">
      <!-- コメント(返信)一覧コンポーネント -->
        <CommentEntries v-for="(comment, index) in entry.comments" 
          :key="index" 
          :parent-entry-id="entry.id" 
          :entry="comment" 
          @change-comment-display="() => changeCommentDisplay(index)" />
      <!-- コメントコンポーネント -->
      <Comment v-show="data.commentDisplay" 
                 :entry = "entry"
                 :refresh-flg="data.commentDisplayRefresh" 
                 :default-accounts="data.defaultAccounts" />
      
      <div class="more-comment" v-show="!isDetailMode() && hasMoreComments()">
        <router-link :to = "{ name:'EntryDetail', params:{ entryId: entry.id} }">他のコメントを見る</router-link>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from 'axios'
import _ from 'lodash'
import Common from '../js/common.js'
import emojis from '../js/emoji.js'
import Global from '../js/constant.js'
import moment from 'moment'
moment.locale('ja')

import { computed, defineEmits, defineProps, onMounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'

import AccountAnchorImage from './image/AccountAnchorImage.vue'
import CircleAnchorImage from './image/CircleAnchorImage.vue'
import CommentCountAnchor from './entry/CommentCountAnchor.vue'
import LabelAccountFollow from './LabelAccountFollow.vue'
import LauncherMenu from './entry/LauncherMenu.vue'
import Comment from './entry/Comment.vue'
import CommentEntries from './entry/comment-entries.vue'
import MarksLink from './entry/MarksLink.vue'
import MarkDialog from './entry/MarkDialog.vue'
import ThumbnailImage from './image/ThumbnailImage.vue'

const $store = useStore()
const $toast = useToast()

const emits = defineEmits(['change-comments'])

// props
const props = defineProps({
  entryDivisionId : {
    type : Number,
    required : true,
  },
  entry : {
    type : Object,
    rquired : true,
  },
  keywords : {
    type : String,
    required : false,
  },
  // 詳細画面として表示するmode
  mode: {
    type: Number,
    required: true,
  }
})

// state
const data = reactive({
  commentDisplay: false,
  commentDisplayRefresh: false,
  commentDisplayOpeningIndex: null,
  comments: null,
  commentCount: 0,
  markCount: 0,
  marksLinkReload: false,
  defaultAccounts: [],
  unreadDisplay: false,
})

// mapstate
const account = computed(() => $store.state.core.account)
const commentReloadEntryId = computed(() => $store.state.entry.commentReloadEntryId)
const circles = computed(() => $store.state.circles.circles)
const filter = computed(() => $store.state.entryFilter.items)
const loginFlg = computed(() => $store.state.core.loginFlg)

// mapmutation
const setCommentReloadEntryId = (val) => $store.commit('setCommentReloadEntryId', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)

// computed
const entry = computed(() => props.entry)

const entryText = computed(() => {
  let text = entry.value.text

  if (account.value != null) {
    entry.value.destinations.forEach(row => {
      text = text.replace(`@${row.account_name}(${row.account_nickname})`, Common.createMentionWithLinkTag(row.account_id, row.account_name, row.account_nickname))
    })
  }
  entry.value.hashtags.forEach(row => {
    let circleMode = entry.value.official_circle == true ? Global.circle_mode.public : Global.circle_mode.private
    let topicName = `${row.topic_name}(${row.official ? '公式' : '自由'})`
    text = text.replace(`#${topicName}`, Common.createHashtagWithLinkTag(circleMode, entry.value.circle_id, row.mst_topic_id, topicName))
  })

  if (props.keywords) {
    // eslint-disable-next-line
    let _keywords = props.keywords.replace(/　/g," ");
    let keywordsAry = _keywords.split(" ")

    keywordsAry.forEach(key => {
      text = text.replace(key, `<span class="keyword">${key}</span>`)
    })
  }
  // テキスト内URLをリンクに置き換え
  text = text.replace(/((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g, '<a href="$1">$1</a>');

  emojis.forEach(row => {
    text = text.replace(row.pattern, `<img src="${row.src}" width="20px" height="20px" style="margin-bottom:-5px">`)
  })
  return text.replace(/\r?\n/g, '<br>')
})

const updated_at = computed(() => {
  if (filter.value.items && Object.values(filter.value?.items).filter(row => row != null).length > 0) {
    return entry.value.updated_at.split('T')[0]
  }
  return moment(entry.value.updated_at, 'YYYY-MM-DD HH:mm:S').fromNow()
  // return entry.value.updated_at
})

watch(commentReloadEntryId, async (val) => {
  if (val === null) return
  if (val !== entry.value.id) return
  data.comments = null
  await getComments()
  setCommentReloadEntryId(null)
})

onMounted(async () => {
  data.markCount = entry.value.mark_count
  if (!entry.value.comments) {
    await getComments()
  }
  data.unreadDisplay = entry.value.already_read_flg === false || (entry.value.unread_marks != null && entry.value.unread_marks.length > 0)
})

// methods
const changeCommentDisplay = (index) => {
  if (data.commentDisplayOpeningIndex == index) { 
    data.commentDisplay = !data.commentDisplay
  } else {
    data.commentDisplay = true  
  }
  data.commentDisplayOpeningIndex = index
  data.commentDisplayRefresh = true

  if (index == null) {
    data.defaultAccounts = [{
      id: props.entry.account_id,
      last_name: props.entry.account_last_name,
      first_name: props.entry.account_first_name,
      nickname: props.entry.account_nickname,
    }]
  } else {
    data.defaultAccounts = [{
      id: entry.value.comments[index].account_id,
      last_name: entry.value.comments[index].account_last_name,
      first_name: entry.value.comments[index].account_first_name,
      nickname: entry.value.comments[index].account_nickname,
    }]
  }
}
// const openWindow = (url) => {
//   window.open(url, '_blank')
// }
const getComments = async () => {
  let params = { entry_id: entry.value.id }
  if (!isDetailMode()) params.limit = Global.limited_comment_count
  await axios.post(Global.url.api_entries_replies, params)
  .then(res=>{
    if ( res.data.status === Global.api_status.success ) {
      entry.value.comments = [...res.data.entries]
      data.commentCount = res.data.all_count
      emits('change-comments')
      return
    }
  })
  .catch(error => {
    $toast.error('client error')
    setClientErrors({func:"common/entry/main.vue::getComments", params: params, errorMessage:error})
  })
}
const toggleMarksLinkReload = () => {
  data.marksLinkReload = !data.marksLinkReload
  data.markCount++
}
const isDetailMode = () => {
  return props.mode === Global.entry_display_mode.detail
}
const hasMoreComments = () => {
  return data.commentCount > Global.limited_comment_count
}
const isEditable = () => {
  if (account.value === null) return false
  if (entry.value.entry_as_circle && isCircleAdmin()) return true
  if (account.value.id === entry.value.account_id) return true 
  return false
}
const isCircleAdmin = () => {
  if (entry.value.circle_id === null) return
  let circle = _.keyBy(circles.value, 'id')[entry.value.circle_id]
  let re = _.filter(circle.members, r => r.id === account.value.id && r.admin_flg)
  return re.length > 0
}
const onVisibilityNew = (_isVisible) => {
  if (!_isVisible) return
  if (account.value == null) return
  if (!entry.value.already_read_flg) {
    let params = {
      account_id: account.value.id, 
      entry_ids: [entry.value.id],
    }
    axios.post(Global.url.api_already_reads_bulk_insert, params).then(res => {
      if (res.data.status == Global.api_status.success) {
        return
      }
    }).catch(error=>{
      $toast.error('client error')
      setClientErrors({func:"common/etnry.vue::watch", params: params, errorMessage:error})
    })
  }
  if (entry.value.unread_marks.length > 0) {
    let entryIds = Array(entry.value.unread_marks.length)
    entryIds.fill(entry.value.id)
    let params = {
      account_id: account.value.id,
      entry_ids: entryIds,
      mark_ids: entry.value.unread_marks,
    }
    axios.post(Global.url.api_already_marks_bulk_insert, params).then(res => {
      if (res.data.status == Global.api_status.success) {
        return
      }
    }).catch(error=>{
      $toast.error('client error')
      setClientErrors({func:"common/etnry.vue::watch", params: params, errorMessage:error})
    })
  }
  data.unreadDisplay = false
}
</script>
<!-- <script>
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
moment.locale('ja')

import Common from '../../js/common.js'
import emojis from '../../js/emoji'

import MarkDialog from './mark-dialog.vue'
import LabelAccountFollow from '../label-account-follow.vue'
import Comment from './comment.vue'
import CommentEntries from './comment-entries.vue'
import MarksLink from './marks-link.vue'
import LauncherMenu from './launcher-menu'
import CommentCountAnchor from './comment-count-anchor'
import _ from 'lodash'

export default {
  props:{
    entryDivisionId : {
      type : Number,
      required : true,
    },
    entry : {
      type : Object,
      rquired : true,
    },
    keywords : {
      type : String,
      required : false,
    },
    // 詳細画面として表示するmode
    mode: {
      type: Number,
      required: true,
    }
  },
  data : function () {
    return {
      commentDisplay: false,
      commentDisplayRefresh: false,
      commentDisplayOpeningIndex: null,
      comments: null,
      commentCount: 0,
      markCount: 0,
      marksLinkReload: false,
      defaultAccounts: [],
      unreadDisplay: false,
    }
  },
  computed : {
    ...mapState([
      'loginFlg',
      'account',
      'circles',
      'filter',
      'commentReloadEntryId',
    ]),
    entryText : function () {
      let text = this.entry.text

      if (this.account != null) _.forEach(this.entry.destinations, (row)=>{
        text = text.replace(`@${row.account_name}(${row.account_nickname})`, Common.createMentionWithLinkTag(row.account_id, row.account_name, row.account_nickname))
      })
      _.forEach(this.entry.hashtags, (row)=>{
        let circleMode = this.entry.official_circle == true ? this.Global.circle_mode.public : this.Global.circle_mode.private
        let topicName = `${row.topic_name}(${row.official ? '公式' : '自由'})`
        text = text.replace(`#${topicName}`, Common.createHashtagWithLinkTag(circleMode, this.entry.circle_id, row.mst_topic_id, topicName))
      })

      if (this.keywords) {
        // eslint-disable-next-line
        let _keywords = this.keywords.replace(//g," ");
        let keywordsAry = _keywords.split(" ")
        _.forEach(keywordsAry, (key)=>{
          text = text.replace(key, `<span class="keyword">${key}</span>`)
        })
      }
      // テキスト内URLをリンクに置き換え
      text = text.replace(/((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g, '<a href="$1">$1</a>');

      _.forEach(emojis, (row) => {
        text = text.replace(row.pattern, `<img src="${row.src}" width="20px" height="20px" style="margin-bottom:-5px">`)
      })
      return text.replace(/\r?\n/g, '<br>')
    },
    updated_at: function () {
      if (Object.values(this.filter.items).filter(row => row != null).length > 0) {
        return this.entry.updated_at.split('T')[0]
      }
      return moment(this.entry.updated_at, 'YYYY-MM-DD HH:mm:S').fromNow()
    }
  },
  watch : {
    marksLinkReload () {
    },
    commentReloadEntryId (val) {
      if (val === null) return
      if (val !== this.entry.id) return
      this.comments = null
      this.getComments()
      this.setCommentReloadEntryId(null)
    },
  },
  created : function () {
    this.markCount = this.entry.mark_count
    if (!this.entry.comments) {
      this.getComments()
    }
  },
  mounted : function () {
    this.unreadDisplay = this.entry.already_read_flg === false || (this.entry.unread_marks != null && this.entry.unread_marks.length > 0)
  },
  methods : {
    ...mapMutations([
      'setCommentReloadEntryId',
      'setClientErrors'
    ]),
    changeCommentDisplay : function (defaultAccounts, index) {
      if (this.commentDisplayOpeningIndex == index) { 
        this.commentDisplay = !this.commentDisplay
      } else {
        this.commentDisplay = true  
      }
      this.commentDisplayOpeningIndex = index
      this.commentDisplayRefresh = true

      if (defaultAccounts) {
        this.defaultAccounts = [defaultAccounts]
      }
    },
    openWindow: function (url) {
      window.open(url, '_blank')
    },
    getComments : function () {
      let params = { entry_id: this.entry.id }
      if (!this.isDetailMode()) params.limit = this.Global.limited_comment_count
      this.axios.post(this.Global.url.api_entries_replies, params)
      .then(res=>{
        if ( res.data.status === this.Global.api_status.success ) {
          this.entry.comments = [...res.data.entries]
          this.commentCount = res.data.all_count
          return
        }
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"common/entry/main.vue::getComments", params: params, errorMessage:error})
      })
    },
    toggleMarksLinkReload : function () {
      this.marksLinkReload = !this.marksLinkReload
      this.markCount++
    },
    isDetailMode : function () {
      return this.mode === this.Global.entry_display_mode.detail
    },
    hasMoreComments : function () {
      return this.commentCount > this.Global.limited_comment_count
    },
    isEditable : function () {
      if (this.account === null) return false
      if (this.entry.entry_as_circle && this.isCircleAdmin()) return true
      if (this.account.id === this.entry.account_id) return true 
      return false
    },
    isCircleAdmin: function () {
      if (this.entry.circle_id === null) return
      let circle = _.keyBy(this.circles, 'id')[this.entry.circle_id]
      let re = _.filter(circle.members, r => r.id === this.account.id && r.admin_flg)
      return re.length > 0
    },
    onVisibilityNew : function (isVisible) {
      if (!isVisible) return
      if (this.account == null) return
      if (!this.entry.already_read_flg) {
        let params = {
          account_id: this.account.id, 
          entry_ids: [this.entry.id],
        }
        this.axios.post(this.Global.url.api_already_reads_bulk_insert, params).then(res => {
          if (res.data.status == this.Global.api_status.success) {
            return
          }
        }).catch(error=>{
          this.$toasted.error('client error')
          this.setClientErrors({func:"common/etnry.vue::watch", params: params, errorMessage:error})
        })
      }

      if (this.entry.unread_marks.length > 0) {
        let entryIds = Array(this.entry.unread_marks.length)
        entryIds.fill(this.entry.id)

        let params = {
          account_id: this.account.id,
          entry_ids: entryIds,
          mark_ids: this.entry.unread_marks,
        }
        this.axios.post(this.Global.url.api_already_marks_bulk_insert, params).then(res => {
          if (res.data.status == this.Global.api_status.success) {
            // this.$toasted.success("insert already_mark success")
            return
          }
          // this.$toasted.error("insert already_mark error")
        }).catch(error=>{
          this.$toasted.error('client error')
          this.setClientErrors({func:"common/etnry.vue::watch", params: params, errorMessage:error})
        })
      }
      this.unreadDisplay = false
    },
    onVisibilityComment: function(isVisible) {
      if (!isVisible) return
      this.getComments()
    },
  },
  components : {
    'c-mark-dialog' : MarkDialog,
    'c-label-account-follow' : LabelAccountFollow,
    'c-comment' : Comment,
    'c-comment-entries' : CommentEntries,
    'c-marks-link' : MarksLink,
    'c-launcher-menu': LauncherMenu,
    'c-comment-count-anchor': CommentCountAnchor,
  }
}
</script> -->
<style scoped>
.circle_border {
  border: 3px solid #ffe499;
}
</style>